import { toastStore } from '@/store/toastStore';

export default {
    success(message) {
        toastStore().success(message);
    },
    error(message) {
        toastStore().error(message);
    }
}